<template>
  <div class="logo-signature-four-brands-content" id="identidade-visual-logo-assinatura-4-marcas" data-search-anchor>
    <div class="title-signature-four-brands-wrapper">
      <h1 class="logo-signature-four-brands-title-span">{{ logoSignature4BrandsTitleSpan }}</h1>
      <h1 class="logo-signature-four-brands-title">{{ logoSignature4BrandsTitle }}</h1>
    </div>
    <div class="description-signature-four-brands-wrapper">
      <div class="logo-signature-four-brands-icon-wrapper">
        <IconCheck />
        <p class="logo-signature-four-brands-description">{{ logoSignature4BrandsDescription }}</p>
      </div>

      <div class="logo-signature-four-brands-icon-wrapper">
        <IconCheck />
        <p class="logo-signature-four-brands-description">{{ logoSignature4BrandsDescription1 }}</p>
      </div>

      <div class="logo-signature-four-brands-icon-wrapper">
        <IconCheck />
        <p class="logo-signature-four-brands-description">{{ logoSignature4BrandsDescription2 }}</p>
      </div>

      <div class="logo-signature-four-brands-icon-wrapper">
        <IconCheck />
        <p class="logo-signature-four-brands-description">{{ logoSignature4BrandsDescription3 }}</p>
      </div>

      <div class="logo-signature-four-brands-icon-wrapper">
        <IconCheck />
        <p class="logo-signature-four-brands-description">{{ logoSignature4BrandsDescription4 }}</p>
      </div>      
      <div  class="logo-signature-four-brands-icon-dica">
        <p class="logo-signature-four-brands-fica-dica">{{ logoSignature4BrandsDescription5 }}</p>
        <p class="logo-signature-four-brands-description-fica-dica">{{ logoSignature4BrandsDescription6 }}</p>
      </div>
    </div>
    <div
      class="logo-signature-four-brands-card-item"
      :style="{ backgroundImage: `url(${logoSignature4BrandsImageSrc})` }"
    ></div>
    <div
      class="logo-signature-four-brands-card-item"
      :style="{ backgroundImage: `url(${logoSignature4BrandsImageSrc1})` }" style="margin-bottom: 0;"
    ></div>
    <div class="title-signature-four-brands-wrapper">
      <h1 class="logo-signature-four-brands-title-span">{{ logoSignature4BrandsAplicacaoTitleSpan }}</h1>
      <h1 class="logo-signature-four-brands-title">{{ logoSignature4BrandsAplicacaoTitle }}</h1>
    </div>
    <div
      class="logo-signature-four-brands-card-item-final"
      :style="{ backgroundImage: `url(${logoSignature4BrandsImageSrc2})`}" 
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LogoSignature4BrandsSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoSignature4BrandsTitleSpan(): string {
    return this.getElementTitle(16, 0)
  }

  get logoSignature4BrandsTitle(): string {
    return this.getElementText(16, 0)
  }

  get logoSignature4BrandsDescription(): string {
    return this.getElementText(16, 1)
  }

  get logoSignature4BrandsDescription1(): string {
    return this.getElementText(16, 2)
  }

  get logoSignature4BrandsDescription2(): string {
    return this.getElementText(16, 3)
  }

  get logoSignature4BrandsDescription3(): string {
    return this.getElementText(16, 4)
  }

  get logoSignature4BrandsDescription4(): string {
    return this.getElementText(16, 5)
  }

  get logoSignature4BrandsDescription5(): string {
    return this.getElementText(16, 6)
  }

  get logoSignature4BrandsDescription6(): string {
    return this.getElementText(16, 7)
  }

  get logoSignature4BrandsImageSrc(): string {
    return this.getElementMedia(16, 7)
  }

  get logoSignature4BrandsImageSrc1(): string {
    return this.getElementMedia(16, 8)
  }

  get logoSignature4BrandsImageSrc2(): string {
    return this.getElementMedia(16, 9)
  }

  get logoSignature4BrandsAplicacaoTitleSpan(): string {
    return this.getElementTitle(16, 9)
  }

  get logoSignature4BrandsAplicacaoTitle(): string {
    return this.getElementText(16, 9)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-signature-four-brands-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.title-signature-four-brands-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-signature-four-brands-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-signature-four-brands-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-signature-four-brands-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%; 
  align-items: flex-start;
}

.logo-signature-four-brands-icon-wrapper{
  display: flex;
  align-items: center;
}

.logo-signature-four-brands-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;
  width: 378px;
}

.logo-signature-four-brands-description-fica-dica {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 378px;
}

.logo-signature-four-brands-card-item {
  position: relative;  
  width: 100%;
  max-width: 1032px;
  height: 705px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-bottom: 1rem;
}

.logo-signature-four-brands-card-item-final {
  position: relative;  
  width: 100%;
  max-width: 1032px;
  height: 538px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-signature-brands-card-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;

  margin: 1rem 0rem 5rem 0rem;
}
.logo-signature-four-brands-fica-dica{
  font-family: InterVariableBold;
  font-size: 16px;  
}
</style>
